'use client';

import { useEffect, useState } from 'react';
import type { ShareButtonProps } from '../ShareButton';
import { ShareButtonSkeleton } from '../ShareButtonSkeleton';
import { ShareButtonGridItemCore } from './ShareButtonGridItemCore/ShareButtonGridItemCore';

/*
 * The ShareButtonGridItemCore is main component.
 * However, it triggers a hydration error because the button cannot be rendered on the server, as window.navigator.share is not present there.
 * On the client, the button can be displayed based on browser support, leading to the hydration error when the button is shown.
 * The solution of displaying the button only after mounting is an antipattern, which is accepted here.
 * The alternative of lazy loading the ShareButton is not worthwhile, as it would require an additional chunk and an extra fetch,
 * which is deemed too excessive for the small code of this component.
 */

/**
 * Displays a 'share' button wrapped by a grid on browsers that support native web-share-api
 * */
export const ShareButtonGridItem = (props: ShareButtonProps) => {
  const [hasBeenRendered, setHasBeenRendered] = useState(false);

  useEffect(() => {
    setHasBeenRendered(true);
  }, []);

  if (!hasBeenRendered) {
    return (
      // grid is rendered here too, so the skeleton is rendered correctly
      <div className="grid-cols-12">
        <ShareButtonSkeleton />
      </div>
    );
  }

  return <ShareButtonGridItemCore {...props} />;
};
